import { render, staticRenderFns } from "./ButtonNotificationComponent.vue?vue&type=template&id=5c63011c&scoped=true&"
import script from "./ButtonNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./ButtonNotificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./ButtonNotificationComponent.vue?vue&type=style&index=0&id=5c63011c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c63011c",
  null
  
)

export default component.exports